module.exports = __webpack_public_path__ + "b919ab2a4362a152546b2f1c8685bc9d.svg";